import { TypeStickyCartWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { mapSpacer } from 'src/siteBuilder/renderer/contentful/mapSpacer'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

// Component
import StickyCart from './StickyCart'

const mapPriceToggleBlock = (props) => props.fields.priceToggle.props.block
const mapDropDownYearTerm = (props) => props.fields.dropDownYearTerm.props.block

const ContentfulStickyCart = withContentful<TypeStickyCartWithoutUnresolvableLinksResponse['fields']>(StickyCart, {
  priceToggle: (props) => {
    return <BlockRenderer block={props.fields.priceToggle} fieldPath={'.priceToggle'} />
  },
  priceToggleBlock: mapPriceToggleBlock,
  planCardSection: (props) => {
    return <BlockRenderer block={props.fields.planCardSection} fieldPath={'.planCardSection'} />
  },
  spacer: mapSpacer,
  heroImage: (props) => {
    return <BlockRenderer block={props.fields.heroImage} />
  },
  customButtonLinkNavProps: (props) => {
    if (props.fields.customButtonLinkNavProps) {
      const { ['buttonLinkProps']: buttonLinkProps, ...rest } = props.fields.customButtonLinkNavProps.fields
      return {
        ...rest,
        buttonLinkProps: buttonLinkProps.fields,
      }
    }
  },
  customButtonLinkCartProps: (props) => {
    if (props.fields.customButtonLinkCartProps) {
      const { ['buttonLinkProps']: buttonLinkProps, ...rest } = props.fields.customButtonLinkCartProps.fields
      return {
        ...rest,
        buttonLinkProps: buttonLinkProps.fields,
      }
    }
  },
  productDetails: (props) => {
    return props.fields?.productDetails?.map((product) => {
      return {
        productId: product.sys.id,
        productIcon: product.fields.productIcon,
        productColor: product.fields.productColor,
        productName: product.fields.productName,
        productNameWithCoupon: product.fields.productNameWithCoupon,
        productPrice: product.fields.productPrice,
        productCouponPrice: product.fields.productCouponPrice,
        productPriceText: product.fields.productPriceText,
        productCouponPriceText: product.fields.productCouponPriceText,
      }
    })
  },
  cartSecondaryButtonFields: (props) => {
    return props.fields.cartSecondaryButton ? true : false
  },
  cartSecondaryButton: (props) => {
    return <BlockRenderer block={props.fields.cartSecondaryButton} />
  },
  dropDownYearTerm: (props) => {
    return <BlockRenderer block={props.fields.dropDownYearTerm} fieldPath={'.dropDownYearTerm'} />
  },
  dropDownYearTermBlock: mapDropDownYearTerm,
})

export default ContentfulStickyCart
